import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';

export const life: LifeFeatureConfig = {
    overview: {
        useCountrySpecificApi: false,
        useBeneficiaryApi: false,
        highlight: {
            showNextPaymentDate: true,
        },
        details: {
            showContractedInsurances: true,
            showVariant: false,
            showPackage: false,
            showContractNumber: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showCoveredRisks: true,
        showUncoveredRisks: true,
        showInsuredPersons: true,
        showBeneficiaries: true,
    },
    history: {
        visible: false,
    },
    risks: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
